/**
 * Organization announcement API – all endpoints used by organization announcement pages.
 * Base path: /admin/announcement (organization announcement routes mounted in backend admin routes).
 */
import {
  DELETE,
  GET,
  POST,
  PUT,
} from "../../apiController";

const ANNOUNCEMENT = '/admin/announcement';

// Create a API endpoint for get Announcements endpoint
export const getAnnouncements = (params) => {
  return GET(`${ANNOUNCEMENT}`, params);
};

export const getAnnouncementsRole = () => {
  return GET(`${ANNOUNCEMENT}/get_announcment_role`);
};

// create a API endpoint for creating announcements
export const createAnnouncement = (data) => {
  return POST(`${ANNOUNCEMENT}`, data);
};

// create a API endpoint for updating announcements
export const updateAnnouncement = (announcement_id, data) => {
  return PUT(`${ANNOUNCEMENT}/${announcement_id}`, data);
};

// create a API endpoint for deleting announcements
export const deleteAnnouncement = (announcement_id) => {
  return DELETE(`${ANNOUNCEMENT}/${announcement_id}`);
};